import { render, staticRenderFns } from "./SelecionarUsuarioDialog.vue?vue&type=template&id=e161897e&"
import script from "./SelecionarUsuarioDialog.vue?vue&type=script&lang=js&"
export * from "./SelecionarUsuarioDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports